import { asField, Option } from "informed";
import React, { Fragment } from "react";
import Select from "react-select";
export const AutocompleteValue = asField(
  ({ fieldState, fieldApi, ...props }) => {
    const { value, label } = fieldState;

    const { setTouched } = fieldApi;
    const {
      field,
      onChange,
      onBlur,
      initialValue,
      forwardedRef,
      excludeEmptyOption,
      emptyValue,
      emptyLabel,
      option,
      options,
      selectedOption,
      getOptionValue,
      getOptionLabel,
      radioInline,
      ...rest
    } = props;

    return (
      <Fragment>
        <div className="form-group">
          {props.label && <label htmlFor={options}>{props.label}</label>}
          <div>
            <Select
              {...rest}
              required
              id={field}
              field={field}
              options={options}
              value={value}
              getOptionLabel={getOptionLabel}
              onChange={(e) => {
                if (onChange) {
                  onChange(e, value);
                }
                console.log(e);
              }}
              onBlur={(e) => {
                setTouched();
                if (onBlur) {
                  onBlur(e);
                }
              }}
            >
              {!excludeEmptyOption && (
                <Option
                  value={emptyValue ? emptyValue : ""}
                  className="custom-control-input"
                >
                  {emptyLabel ? emptyLabel : "Select the option"}
                </Option>
              )}
              {options &&
                options.map((option, i) => (
                  <Option
                    style={{
                      width: "50px !important",
                      color: "black!important",
                    }}
                    value={
                      getOptionValue
                        ? getOptionValue(option)
                        : option.value
                        ? option.value
                        : option
                    }
                    id={`${field}-${i}`}
                    className="custom-control-input"
                    key={i}
                  >
                    {i.getOptionLabel
                      ? getOptionLabel(option)
                      : option.label
                      ? option.label
                      : option}
                    {/* {  console.log(";;;;;;iiiiiiiii",value)} */}
                  </Option>
                ))}
              {/* {  console.log(";;;;;;iiiiiiiii",i)} */}
              {/* {    console.log(";;;;222222222")} */}
            </Select>
          </div>
          {fieldState.error ? (
            <div className="invalid-field">{fieldState.error}</div>
          ) : null}
        </div>
      </Fragment>
    );
  }
);
